<div class="app-container">
  <public-header [matchflowBaseUrl]="therapyMatchFlowUrl"></public-header>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isValid; else notFound">
      <main class="main-content">
        <section class="provider-profile">
          <div class="provider-header">
            <br *ngIf="noProfilePhoto">
            <div *ngIf="!noProfilePhoto" class="image-container">
              <img 
                src="{{ providerShareableProfile.profile_photo_url }}" 
                alt="{{ providerShareableProfile.display_name }} profile image" 
                class="provider-image"
                fetchpriority="high"
              >
              <div 
                class="not-accepting-clients not-accepting-clients-desktop"
                *ngIf="!providerShareableProfile.accepting_clients"
                data-test="not-accepting-clients"
              >
                Currently not accepting new clients
              </div>
            </div>

            <div class="provider-header-details">
              <div class="names-and-pronouns-container">
                <h1 class="provider-name" data-test="provider-display-name">{{ providerShareableProfile.display_name }}</h1>
                <span class="provider-pronouns" *ngIf="providerShareableProfile?.pronouns?.length > 0">
                  ({{ providerShareableProfile.pronouns }})
                </span>
              </div>
              <p class="provider-credentials" *ngFor="let certification of providerShareableProfile.certifications">
                {{ certification.name }}
              </p>
              
              <div class="type-and-insurance-container">
                <p class="provider-session-type">
                  <img
                    src="../assets/place.png"
                    alt="location icon" 
                    fetchpriority="low"
                  >
                  {{sessionTypeList}}
                </p>
                <p *ngIf="providerShareableProfile?.credentialed_states?.length > 0" class="provider-state">
                  Practicing in {{credentialStatesFormatted}}
                </p>
                <div *ngIf="providerShareableProfile.insurances.length > 0; else selfPay">
                  <p class="provider-header-insurance-title">
                    <img
                      src="../assets/shield.png"
                      alt="shield icon"
                      fetchpriority="low"
                    >
                    Insurance
                  </p>
                  <p class="provider-header-insurances-accepted">
                    {{ providerInsurances | slice:0:36 }}{{providerInsurances.length > 36 ? '...' : ''}}
                  </p>
                </div>
                <button 
                  class="show-insurance-list-button" 
                  *ngIf="providerInsurances.length > 36" 
                  (click)="scrollToElement('insurances-section')"
                  data-test="show-insurance-list-button"
                  tabindex="0"
                >
                  See all below
                </button>
              </div>

              <div
                *ngIf="providerShareableProfile.psl_feature_flag"
                class="scheduling-container"
                data-test="scheduling-container"
              >
                <a
                  *ngIf="providerShareableProfile.accepting_clients"
                  [routerLink]="['/match', paramsShareCode, paramsName]"
                  [queryParams]="requestSessionQueryParams"
                  class="nav-link request-session-button"
                  data-test="request-session-button"
                  tabindex="0"
                >
                  Request a Session
                </a>

                <div 
                  class="not-accepting-clients-cta-desktop"
                  *ngIf="!providerShareableProfile.accepting_clients"
                  data-test="not-accepting-clients"
                >
                  <button class="non-accepting-match-button" data-test="non-accepting-match-button">
                    <a 
                      [href]="therapyMatchFlowUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get matched with similar therapists
                      <iris-icon
                        class="link-arrow"
                        name="arrow_line_right"
                        [usage]="iconUsage"
                        [color]="iconColor"
                        [size]="iconSize"
                      ></iris-icon>
                    </a>
                  </button>
                  <div class="phone-number">
                    Or, our Care Coordinators can easily help you find a therapist over the phone. 
                    <span class="call-cta">Call <a href="tel:{{ bookSessionPhoneLink }}">{{ bookSessionPhoneDisplay }}</a></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          *ngIf="providerShareableProfile.psl_feature_flag && !providerShareableProfile.accepting_clients" 
          class="not-accepting-clients-cta-mobile"
        >
          <p class="not-accepting-clients not-accepting-clients-mobile">Currently not accepting new clients.</p>
          <button class="non-accepting-match-button">
            <a 
              [href]="therapyMatchFlowUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get matched with similar therapists
              <iris-icon
                class="link-arrow"
                name="arrow_line_right"
                [usage]="iconUsage"
                [color]="iconColor"
                [size]="iconSize"
              ></iris-icon>
            </a>
          </button>
          <div class="phone-number">
            Or, our Care Coordinators can easily help you find a therapist over the phone. 
            <span class="call-cta">Call <a href="tel:{{ bookSessionPhoneLink }}">{{ bookSessionPhoneDisplay }}</a></span>
          </div>
        </div>
    
        <div class="provider-details">
          <section class="info" *ngIf="providerShareableProfile?.specialties?.length > 0">
            <section class="specialties">
              <h2>Specialties</h2>
              <ul>
                <li *ngFor="let specialty of providerShareableProfile.specialties">
                  {{ specialty.name }}
                </li>
              </ul>
            </section>
          
            <section *ngIf="experienceSupportingList?.length > 0" class="experience">
              <h2>Experience Supporting</h2>
              <ul>
                <li *ngFor="let experience of experienceSupportingList">
                  {{ experience }}
                </li>
              </ul>
            </section>
          </section>

          <section
            *ngIf="providerBio?.length"
            id="about-section"
            class="about"
          >
            <h2>About</h2>
            <p data-test="provider-bio">{{providerBio}}</p>
            <button
              *ngIf="isBioTruncated && providerBio.length >= 500"
              (click)="toggleBioTruncation()"
              class="read-more"
            >
              read more
            </button>
            <button
              *ngIf="!isBioTruncated && providerBio.length >=500"
              (click)="toggleBioTruncation()"
              class="read-more"
            >
              read less
          </button>
          </section>

          <section *ngIf="providerShareableProfile.insurances.length > 0" id="insurances-section" class="insurance">
            <h2>Insurance</h2>
            <ul>
              <li *ngFor="let insurance of providerShareableProfile.insurances">
                {{ insurance }}
              </li>
            </ul>
          </section>
        </div>

        <!-- Footer is contained within main to have body + footer be scrollable together -->
        <footer >
          <public-footer [matchflowBaseUrl]="therapyMatchFlowUrl">
          </public-footer>
        </footer>
      </main>
    </ng-container>

    <ng-template #notFound>
      <div class="page-not-found-container">
        <page-not-found [therapyMatchFlowUrl]="therapyMatchFlowUrl"></page-not-found>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <mat-spinner [diameter]="40"></mat-spinner>
  </ng-template>

  <ng-template #selfPay>
    <p class="provider-header-insurance-title">
      <img
        src="../assets/shield.png"
        alt="shield icon"
        fetchpriority="low"
      >
      Accepts self-pay only
    </p>
    <br/>
  </ng-template>
</div>
  